import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const capitalize = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1);

// "28 de octubre de 2026"
export const formatPublishedDate = (isoDate: string) =>
  format(new Date(isoDate), "d 'de' MMMM 'de' yyyy", { locale: es });

// "28 oct 2026", for the index column.
export const formatShortDate = (isoDate: string) =>
  format(new Date(isoDate), 'd MMM yyyy', { locale: es });

// "Octubre 2026", the list's month headings.
export const formatMonth = (isoDate: string) =>
  capitalize(format(new Date(isoDate), 'MMMM yyyy', { locale: es }));

// "Martes 3 de noviembre de 2026", the front page's dateline.
export const formatDateline = (date: Date) =>
  capitalize(format(date, "EEEE d 'de' MMMM 'de' yyyy", { locale: es }));

// "28" and "oct", stacked in the list's date column.
export const formatDayAndMonth = (isoDate: string) => ({
  day: format(new Date(isoDate), 'd', { locale: es }),
  month: format(new Date(isoDate), 'MMM', { locale: es }),
});
